import React, { useEffect, useState, useMemo } from "react";
import { Modal, Row, Col, notification, Button, Skeleton, Divider } from "antd";
import axios from "axios";

const confirm = Modal.confirm;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({ message, description });
};

const parseJson = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const SECOES = [
    { key: "participacao", label: "1. Participação" },
    { key: "desenvolvimento_cognitivo", label: "2. Desenvolvimento Cognitivo" },
    { key: "linguagem_comunicacao", label: "3. Linguagem e Comunicação" },
    { key: "movimento_motor", label: "4. Desenvolvimento Motor" },
    { key: "socializacao", label: "5. Socialização" },
    { key: "consideracoes_finais", label: "6. Considerações Finais" }
];

const ModalRelatorioIndividual = ({ id, visible, onCancel, onDelete }) => {
    const [relatorio, setRelatorio] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const apresentacao = useMemo(() => parseJson(relatorio?.apresentacao), [relatorio?.apresentacao]);

    const carregarDetalhe = id => {
        setIsLoading(true);
        axios({ method: "get", url: "/api/relatorio-individual/carregar-relatorio-individual", params: { id } })
            .then(response => setRelatorio(response.data || {}))
            .catch(error => openNotificationWithIcon("error", "Erro", "Não foi possível carregar o relatório."))
            .finally(() => setIsLoading(false));
    };

    const validarExcluir = () => {
        confirm({
            title: "Pretende remover este relatório?",
            okText: "Confirmar",
            cancelText: "Cancelar",
            okType: "danger",
            onOk: () => excluir()
        });
    };

    const excluir = () => {
        axios({ method: "put", url: "/api/relatorio-individual/excluir-relatorio-individual", params: { id } })
            .then(() => {
                openNotificationWithIcon("success", "Relatório removido", "O relatório foi removido com sucesso.");
                onDelete();
            })
            .catch(error => openNotificationWithIcon("error", "Erro", "Não foi possível excluir o relatório."));
    };

    useEffect(() => {
        if (id && visible) carregarDetalhe(id);
    }, [id]);

    // ── Render helpers ───────────────────────────────────────────────────────

    const renderField = (label, value, span = 12) => (
        <Col span={span} style={{ marginBottom: 12 }}>
            <span className="field-label">{label}</span>
            <Skeleton loading={isLoading} paragraph={false} active className="field-skeleton">
                <p className="field-value" style={{ fontWeight: "bold", marginBottom: 0 }}>
                    {value || "-"}
                </p>
            </Skeleton>
        </Col>
    );

    const renderFieldWide = (label, value) => (
        <Col span={24} style={{ marginBottom: 12 }}>
            {label && <span className="field-label">{label}</span>}
            <Skeleton loading={isLoading} title={false} active className="field-skeleton">
                <p className="field-value--wide" style={{ fontWeight: "bold", marginBottom: 0 }}>
                    {value || "-"}
                </p>
            </Skeleton>
        </Col>
    );

    return (
        <Modal
            title={
                <div>
                    <div style={{ fontWeight: "bold", fontSize: 16 }}>Relatório Individual</div>
                    <div style={{ fontSize: 12, color: "#888" }}>Visualização do relatório individual</div>
                </div>
            }
            className="modal-detalhe-info"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancelar" onClick={onCancel}>
                    Fechar
                </Button>,
                <Button key="eliminar" className="modal-detalhe-info-delete-btn" type="danger" onClick={validarExcluir}>
                    Excluir Relatório
                </Button>
            ]}
            centered
            width={800}
            bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
        >
            <div className="modal-detalhe-info__body">
                <div className="modal-detalhe-info__section">
                    {/* Apresentação */}
                    <Divider orientation="left" style={{ fontWeight: "bold" }}>
                        Apresentação
                    </Divider>
                    <Row gutter={16} style={{ marginBottom: 12 }}>
                        {renderField("Aluno", apresentacao.aluno)}
                        {renderField("Turma", apresentacao.turma)}
                        {renderField("Professora", apresentacao.professora)}
                        {renderField("Período", apresentacao.periodo)}
                    </Row>

                    {/* Secções */}
                    {SECOES.map(({ key, label }) => (
                        <React.Fragment key={key}>
                            <Divider orientation="left" style={{ fontWeight: "bold" }}>
                                {label}
                            </Divider>
                            <Row gutter={16} style={{ marginBottom: 12 }}>
                                {renderFieldWide(null, relatorio?.[key])}
                            </Row>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export default ModalRelatorioIndividual;
